import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

/**
 * Guard d'authentification pour protéger les routes.
 * Vérifie si l'utilisateur est connecté via Keycloak.
 * Si non connecté, redirige vers la page de login Keycloak.
 * 
 * Utilisation dans app.routes.ts :
 * { path: 'protected', component: MyComponent, canActivate: [authGuard] }
 */
export const authGuard = async () => {
  const platformId = inject(PLATFORM_ID);
  const keycloak = inject(KeycloakService);
  const router = inject(Router);

  // En mode SSR, autoriser l'accès (la vérification se fera côté client)
  if (!isPlatformBrowser(platformId)) {
    console.log('[Auth Guard] SSR détecté - accès autorisé');
    return true;
  }

  try {
    // Attendre que Keycloak soit complètement initialisé
    const isLoggedIn = await keycloak.isLoggedIn();
    
    console.log('[Auth Guard] Statut authentification:', isLoggedIn);

    if (!isLoggedIn) {
      console.log('[Auth Guard] Utilisateur non connecté - redirection vers login');
      
      // Rediriger vers Keycloak pour authentification
      await keycloak.login({
        redirectUri: window.location.href // Revenir à la page demandée après login
      });
      
      return false;
    }

    console.log('[Auth Guard] Accès autorisé');
    return true;
    
  } catch (error) {
    console.error('[Auth Guard] Erreur lors de la vérification:', error);
    
    // En cas d'erreur, tenter de se connecter
    try {
      await keycloak.login({
        redirectUri: window.location.href
      });
    } catch (loginError) {
      console.error('[Auth Guard] Erreur lors du login:', loginError);
    }
    
    return false;
  }
};